export let ContentSource;

(function (ContentSource) {
  ContentSource["PromotedClosets"] = "promoted_closets";
  ContentSource["UserItems"] = "user_items";
  ContentSource["FavouriteItems"] = "favorite_items";
  ContentSource["BundleItems"] = "bundle";
  ContentSource["Catalog"] = "catalog";
  ContentSource["Search"] = "search";
  ContentSource["PopularItems"] = "popular_items";
  ContentSource["PromotedCatalog"] = "catalog_promoted_items";
  ContentSource["PromotedSearch"] = "search_promoted_items";
  ContentSource["PromotedPopularItems"] = "popular_promoted_items";
  ContentSource["ListerActivationBanner"] = "lister_activation_banner";
  ContentSource["Transaction"] = "transaction";
  ContentSource["Settings"] = "settings";
  ContentSource["CatalogPromotedClosets"] = "catalog_promoted_closets";
  ContentSource["SearchPromotedClosets"] = "search_promoted_closets";
  ContentSource["SimilarItems"] = "similar_items";
  ContentSource["OtherUserItems"] = "other_user_items";
  ContentSource["AdCatalog"] = "catalog_ad";
  ContentSource["AdSearch"] = "search_ad";
  ContentSource["AdFeed"] = "feed_ad";
  ContentSource["FeaturedCollection"] = "featured_collection";
  ContentSource["RecommendedItems"] = "recommended_items";
  ContentSource["GalleriedItems"] = "galleried_items";
  ContentSource["FollowedUsers"] = "followed_users";
})(ContentSource || (ContentSource = {}));